import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

// The badge is the icon itself: padding shrinks the glyph inside the box, so no wrapper is needed.
// Shared by the cards that put an affordance next to their content.
// font-size drives the glyph scale (FontAwesome renders it at 1em); padding sets the box around it.
const StIconBadge = styled(FontAwesomeIcon)`
  ${({ theme }) => `
    box-sizing: content-box;
    flex-shrink: 0;
    font-size: ${theme.UI.SpacingPx.Space5};
    padding: ${theme.UI.SpacingPx.Space2};
    border-radius: ${theme.UI.BorderRadius.Small}px;
    color: ${theme.Components.Button.Primary.Text};
    background-color: ${theme.Components.Button.Primary.Fill};
  `}
`

export { StIconBadge }
